<template>
  <div>
    <el-form-item label="客户资源">
      <remote-select v-model="formData.assign_customer_ids"
                     class="select-width"
                     clearable
                     multiple
                     id-key="number"
                     label-key="name"
                     value-key="id"
                     placeholder="请选择客户"
                     :query-request="getCustomerTable"
                     :find-request="getCustomerDetail">
      </remote-select>
    </el-form-item>

    <el-form-item label="UI权限角色">
      <remote-select v-model="formData.ui_role_ids"
                     class="select-width"
                     clearable
                     multiple
                     id-key="id"
                     label-key="name"
                     value-key="id"
                     keyword-key="name"
                     placeholder="请选择UI权限角色"
                     :query-request="forwardCoreUiRoleQueryApi"
                     :find-request="forwardCoreUiRoleDetailApi">
      </remote-select>
    </el-form-item>

    <el-form-item label="API权限角色">
      <remote-select v-model="formData.api_role_ids"
                     class="select-width"
                     clearable
                     multiple
                     id-key="id"
                     label-key="name"
                     value-key="id"
                     keyword-key="name"
                     placeholder="请选择API权限角色"
                     :query-request="forwardCoreApiRoleQueryApi"
                     :find-request="forwardCoreApiRoleDetailApi">
      </remote-select>
    </el-form-item>
  </div>
</template>

<script>
import RemoteSelect from '@core/components/RemoteSelect.vue'

export default {
  components: {RemoteSelect},
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  computed: {
    formData: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  methods: {
    ...request.map([
      'getCustomerTable', 'getCustomerDetail', 'forwardCoreApiRoleQueryApi',
      'forwardCoreApiRoleDetailApi', 'forwardCoreUiRoleQueryApi', 'forwardCoreUiRoleDetailApi',
    ]),
  },
}
</script>

<style lang="scss"
       scoped>
.id-card-upload-wrapper {
  display: flex;
  gap: 16px;
}

.id-card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.id-card-uploader .el-upload {
  width: 100px;
  height: 100px;
  line-height: 80px;
}

.id-card-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.id-card-placeholder:hover {
  border-color: #409EFF;
}

.id-card-placeholder i {
  font-size: 20px;
  margin-bottom: 4px;
}

.id-card-placeholder span {
  font-size: 12px;
}

.id-card-avatar {
  font-size: 10px;
  width: 100px;
  height: 100px;
  display: block;
  object-fit: cover;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/components/ResourceForm.vue